<template>
  <va-card>
    <div class="about-card-content">
      <div class="about-image-container">
        <img src="../../assets/nadia-kona.jpg" alt="Nadia and Kona" />
      </div>
      <div class="descriptions">
        <div class="description">
          Nadia Magallon is a certified professional dog trainer
          (<a href="https://www.ccpdt.org/dog-owners/how-to-choose-a-dog-trainer/"
            alt="CPDT-KA"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >CPDT-KA</a>)
          and a certified separation anxiety trainer
          (<a href="https://malenademartini.com/for-owners/why-hire-csat-trainer/"
            alt="CSAT"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >CSAT</a>).
          She became interested in the world of dog training after
          adopting Kona, an anxious, reactive pit bull mix in 2017 and subsequently enrolling in countless group
          and private lessons. Nadia began volunteering at
          <a href="https://www.trainingwheels.dog/"
            alt="Training Wheels"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Training Wheels</a>
          in 2019 to gain extra hands on experience
          with dogs with a range of behavioral challenges. She has trained over 100 dogs
          in basic manners, calmness, reactivity, resource guarding, tricks, and more!
        </div>
        <div class="description">
          Nadia graduated from MIT with a BS in Systems Engineering.
          She pairs her engineering skills with her software engineering
          expertise to create a custom learning platform for her clients.
          She is passionate about using technology to help people learn better and
          have a positively rewarding experience for both human and dog alike.
        </div>
        <div class="description">
          Seeing how Nadia has a lifelong proclivity for science, it was a no brainer that she would turn to science to discover what are
          the most effective dog training techniques. Positive reinforcement training (using force free, humane methods) has proven
          time and time again in research studies to not only be more effective for teaching animals quickly but also teaching
          animals how to learn better over time! I highly recommend reading the resources at
          <a href="https://www.companionanimalpsychology.com/p/resources.html"
            alt="Companion Animal Psychology"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Companion Animal Psychology</a>
          for a great collection of scientific studies that are easy to comprehend.
        </div>
      </div>
    </div>
  </va-card>
</template>

<script>

export default {
  name: 'about-card',
}
</script>

<style scoped lang="scss">
  .about-card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @include media-breakpoint-up(lg) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }

    .about-image-container {
      width: 90%;
      overflow: hidden;

      @include media-breakpoint-up(lg) {
        height: 120%;
        width: auto;
        margin-top: 2rem;
      }

      img {
        width: 100%;
        border-radius: 0.375rem;
      }
    }

    .descriptions {
      .description {
        margin-top: 1rem;

        @include media-breakpoint-up(lg) {
          margin-left: 7%;
        }
      }
    }

    link:hover {
      filter: brightness(85%);
    }
  }
</style>
